import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { getUserRole, signOut } from '../../../services/common/auth';

const messages = [
  'Por favor, ingrese su correo electrónico y contraseña.',
  'El correo electrónico o la contraseña son incorrectos.',
];

function useLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setCurrentUser, signInUser } = useAuth();

  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [pending, setPending] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openError, setOpenErr] = useState(false);
  const [errorMessage, setErrorMessage] = useState(messages[0]);

  useEffect(() => {
    //console.log("useLogin - useEffect");
    const checkAuth = async () => {
      try {
        const res = await Auth.currentAuthenticatedUser();
        const user = { username: res.username };
        const role = await getUserRole(res.username);

        if (role === 'crm' || role === 'admin' || role === 'customers') {
          setCurrentUser(user);
          setPending(false);
          const origin = location.state?.from?.pathname || '/home';
          navigate(origin);
        } else {
          await signOut();
          setCurrentUser(null);
          setPending(false);
        }
      } catch (error) {
        console.log("Error [checkAuth] ", error);
        setCurrentUser(null);
        setPending(false);
      }
    };

    checkAuth();
    /* Auth.signOut(); */
  }, []);

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const onChangePass = (event) => {
    setPass(event.target.value);
  };

  const handleOpen = () => {
    setOpenErr(true);
  };

  const handleClose = () => {
    setOpenErr(false);
  };

  const onLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    handleClose();

    if (email && pass) {
      const res = await signInUser(email, pass);
      if (!res) {
        handleOpen();
        setErrorMessage(messages[1]);
      }
    } else {
      setErrorMessage(messages[0]);
      handleOpen();
    }

    setIsLoading(false);
  };

  return {
    email,
    pass,
    pending,
    isLoading,
    openError,
    errorMessage,
    onChangeEmail,
    onChangePass,
    onLogin,
    handleClose,
    handleOpen,
  };
}

export default useLogin;